import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button } from "@material-ui/core";
import "./stripe.css";

const CheckoutForm = (props: any) => {
  const stripe: any = useStripe();
  const elements: any = useElements();

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);
    if (result.error) {
      console.log("error");
      // Inform the user if there was an error.
    } else {
      // Send the token to your server.
      props.onSubmit2(result);
    }
  };

  return (
    <form className="sf-stripe-form" onSubmit={handleSubmit}>
      <CardElement />
      <Button
        className="ha-btn-green sf-ipca-stripe-add-card"
        type="submit"
        disabled={!stripe}
      >
        {props.btnText ? props.btnText : "Add Card"}
      </Button>
    </form>
  );
};
export const CheckoutForm2 = (props: any) => {
  const stripe: any = useStripe();
  const elements: any = useElements();

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    // event.preventDefault();

    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);
    if (result.error) {
      console.log("error");
      // Inform the user if there was an error.
    } else {
      // Send the token to your server.
      console.log("token", result);
    }
    props.onSubmit2(result);
  };

  return (
    <form className="sf-stripe-form2" onSubmit={handleSubmit}>
      <CardElement />
      <Button
        style={{ height: "56px", width: "100%" }}
        className="ha-btn-green"
        type="submit"
      >
        Add Card
      </Button>
    </form>
  );
};
export default CheckoutForm;
